var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":_vm._APIhost + "/CustomerData/" + _vm.userInfo.companyName + "/Forms/BannerImages/" + _vm.formElement.dynamicTypeData.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }